import { render, staticRenderFns } from "./doc_detail.vue?vue&type=template&id=5cc77b3f&scoped=true"
import script from "./doc_detail.vue?vue&type=script&lang=js"
export * from "./doc_detail.vue?vue&type=script&lang=js"
import style0 from "./doc_detail.vue?vue&type=style&index=0&id=5cc77b3f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc77b3f",
  null
  
)

export default component.exports